import { resolveMembersAccessLevel } from '@/helpers/adminPermissions';
import {
  ADMIN_PERMISSION_ACCESS_LEVEL,
  ADMIN_PERMISSION_RESOURCE_TYPE,
  type GroupAdminGroupView,
  type GroupAdminGroupsPayload,
} from '@/types';

export type GroupAdminAccessLevel = ADMIN_PERMISSION_ACCESS_LEVEL.EDIT | ADMIN_PERMISSION_ACCESS_LEVEL.VIEW_ONLY;

export const DEFAULT_GROUP_ADMIN_ACCESS_LEVEL: GroupAdminAccessLevel = ADMIN_PERMISSION_ACCESS_LEVEL.EDIT;

export const GROUP_ADMIN_ACCESS_LEVEL_LABEL_KEYS: Record<GroupAdminAccessLevel, string> = {
  [ADMIN_PERMISSION_ACCESS_LEVEL.EDIT]: 'appSetup.permissions.accessLevels.edit',
  [ADMIN_PERMISSION_ACCESS_LEVEL.VIEW_ONLY]: 'appSetup.permissions.accessLevels.viewOnly',
};

export const GROUP_ADMIN_ACCESS_LEVEL_BADGE_COLOR: Record<GroupAdminAccessLevel, string> = {
  [ADMIN_PERMISSION_ACCESS_LEVEL.EDIT]: 'brand',
  [ADMIN_PERMISSION_ACCESS_LEVEL.VIEW_ONLY]: 'gray',
};

export const getGroupAdminAccessLevel = (group: GroupAdminGroupView): GroupAdminAccessLevel =>
  resolveMembersAccessLevel({
    permissions: group.permissions,
  });

export const buildGroupAdminGroupsPayload = ({
  groups,
}: {
  groups: { id: string; accessLevel: GroupAdminAccessLevel }[];
}): GroupAdminGroupsPayload =>
  groups.reduce<GroupAdminGroupsPayload>((acc, { id, accessLevel }) => {
    acc[id] = {
      id,
      permissions: [
        {
          resourceType: ADMIN_PERMISSION_RESOURCE_TYPE.MEMBERS,
          accessLevel,
        },
      ],
    };

    return acc;
  }, {});
